import { MIXPANEL_EVENT_PROPERTIES } from '../../../../shared/mixpanel';

export type LogoPayload = {
    logoPosition: number;
    variationPosition: number;
    sellerId: string;
    projectId: string;
    variationId: string;
    engineType: string;
    algoPool: string;
    symbolQuality: number;
    variationsQuality: number;
    rpi: number;
};

export const getCardEnrichment = (logoPayload: LogoPayload) => ({
    [MIXPANEL_EVENT_PROPERTIES.LOGO_POSITION]: logoPayload.logoPosition,
    [MIXPANEL_EVENT_PROPERTIES.VARIATION_POSITION]:
        logoPayload.variationPosition,
    [MIXPANEL_EVENT_PROPERTIES.SELLER_ID]: logoPayload.sellerId,
    [MIXPANEL_EVENT_PROPERTIES.PROJECT_ID]: logoPayload.projectId,
    [MIXPANEL_EVENT_PROPERTIES.VARIATION_ID]: logoPayload.variationId,
    [MIXPANEL_EVENT_PROPERTIES.ENGINE_TYPE]: logoPayload.engineType,
    [MIXPANEL_EVENT_PROPERTIES.ALGO_SOURCE]: logoPayload.algoPool,
    [MIXPANEL_EVENT_PROPERTIES.SYMBOL_QUALITY]: logoPayload.symbolQuality,
    [MIXPANEL_EVENT_PROPERTIES.VARIATION_QUALITY]:
        logoPayload.variationsQuality,
    [MIXPANEL_EVENT_PROPERTIES.RPI]: logoPayload.rpi,
});
